<div id="pdf_print_area_2" #pdf_print_area_2 class="row">
    <div class="col-lg-12 col-md-12">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>OTC Market Value Share by Package Size</h3>
            </div>
            <div class="filter-section ssmm-filter otc-section even-wrapper">

                <!-- <div class="ng-section summary-section native">
                    <b>Aggregate By</b>
                    <select class="form-control filter-by-category form-basic" (change)="onOTCMarketsizeAggregateChange($event.target.value)">
                        <option value="wtd">Weekly</option>
                        <option value="mtd">Monthly</option>
                        <option value="qtd">Quarterly</option>
                        <option value="ytd">Yearly</option>
                    </select>
                </div> -->
                <single-dropdown title="Aggregate By"
                    [items]="[{value: 'wtd', name: 'Week to Date'}, {value: 'mtd', name: 'Month to Date'}, {value: 'qtd', name: 'Quarter to Date'}, {value: 'ytd', name: 'Year to Date'}]"
                    [model]="aggregateBy"
                    (change)="onOTCMarketsizeAggregateChange($event)">
                </single-dropdown>

                <div class="ng-section summary-section">
                    <b>Channel</b>
                    <ng-select #ngFilterChannelShare class="filter-by-category" [searchable]="false" [virtualScroll]="true" [(ngModel)]="selectedChannel[0]" [multiple]="false" [closeOnSelect]="false"
                    (remove)="onRemoveFilterOTCChannel($event)"
                    (change)="onRemoveFilterOTCChannel($event);onChangeCheckBox($event)"
                    (open)="SaveOptionValueTemp(false);onChangeCheckBox($event)"
                    (blur)="SaveOptionValueTemp(true)"
                    [clearable]="selectedChannel.length > 1"
                    (add)="onAddFilteOTCChannel($event)">
                        <ng-option *ngFor="let item of smddChanelOrder" [value]="item.channel">
                            <input type="checkbox" class="cb-multi-select"/> {{isSmddChild(item.channel) ? "&nbsp;&nbsp;&nbsp;" : ""}}{{item.channel}}</ng-option>
                            <ng-template ng-footer-tmp>
                                <button type="submit" class="btn btn-primary"
                                (click)="SaveOptionValueTemp(false);ngFilterChannelShare.close();onFilterByChannelChange()">Aggregate</button>
                            </ng-template>                                
                            <ng-template ng-multi-label-tmp let-items="items">
                            <ng-container *ngFor="let item of items; index as i">
                                <ng-container *ngIf="i==0">
                                    {{item}}
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="items.length > 1">
                                ...
                            </ng-container>
                        </ng-template>
                    </ng-select>

                </div>
                <div class="ng-section summary-section">
                    <b>Region</b>
                    <ng-select #ngFilterRegionShare class="filter-by-category ng-region" [searchable]="false" [virtualScroll]="true" [(ngModel)]="marketShareSelectedRegion[0]" [multiple]="false" [closeOnSelect]="false"
                    (remove)="onRemoveFilterShareRegion($event)"
                    (change)="onRemoveFilterShareRegion($event);onChangeCheckBox($event)"
                    (open)="SaveOptionValueTemp(false);onChangeCheckBox($event)"
                    (blur)="SaveOptionValueTemp(true)"
                    [clearable]="marketShareSelectedRegion.length > 1"
                    (add)="onAddFilterShareRegion($event)">
                        <ng-option *ngFor="let item of summaryRegions" [value]="item"><input type="checkbox" class="cb-multi-select"/> {{item}}</ng-option>
                        <ng-template ng-footer-tmp>
                            <button type="submit" class="btn btn-primary"
                            (click)="SaveOptionValueTemp(false);ngFilterRegionShare.close();onMarketShareRegionChange()">Aggregate</button>
                        </ng-template>                                
                        <ng-template ng-multi-label-tmp let-items="items">
                            <ng-container *ngFor="let item of items; index as i">
                                <ng-container *ngIf="i==0">
                                    {{item}}
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="items.length > 1">
                                ...
                            </ng-container>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="card-body">
                <div #scroll class="market-size">
                    <table #screen class="intage-market-size">
                        <tr>
                            <th colspan="3" class="summary-row-col">Channel</th>
                            <th *ngFor="let item of categories; index as i;" [style]="'background-color:' + getCategoryColor(item)">{{getCategoryDisplayName(item)}}</th>
                        </tr>
                        <ng-container *ngFor="let packageType of marketSizeBySSMMData; index as i;">
                            <tr>
                                <ng-container *ngIf="i==0">
                                    <td class="first-left-col" [attr.rowspan]="marketSizeBySSMMData.length*2"><b>Market Size</b></td>
                                </ng-container>
                                <td rowspan="2" [class]="i == marketSizeBySSMMData.length - 1 ? 'last-row-td' : ''" class="second-left-col">{{packageType.packageType}}</td>
                                <td class="bg-row third-left-col ssmm">% vs LY</td>
                                <td class="bg-row" *ngFor="let item of categories; index as j;">
                                    <b [class]="getVsLyOfCategoryForMarketSize(packageType.categories, item).indexOf('-') != -1 ? 'text-red': ''">
                                        {{getVsLyOfCategoryForMarketSize(packageType.categories, item).indexOf('-') != -1 ? '': '+'}}{{getVsLyOfCategoryForMarketSize(packageType.categories, item)}}
                                    </b>
                                </td>
                            </tr>
                            <tr [class]="i == marketSizeBySSMMData.length - 1 ? 'last-row' : ''">
                                <td class="third-left-col ssmm">IMP</td>
                                <td *ngFor="let item of categories; index as j;">{{getImpOfCategory(packageType.categories, item)}}</td>
                            </tr>
                        </ng-container>
                        <ng-container *ngFor="let maker of marketShareBySSMMData; index as i;">
                            <ng-container *ngFor="let packageType of maker.packageTypes; index as j;">
                                <tr>
                                    <ng-container *ngIf="j == 0">
                                        <td class="first-left-col" [attr.rowspan]="maker.packageTypes.length * 2">
                                            <ng-container *ngIf="maker.logo == ''">
                                                <span class="maker-name">{{maker.maker}}</span>
                                            </ng-container>
                                            <ng-container *ngIf="maker.logo != ''">
                                                <img class="maker-logo" src="{{maker.logo}}" />
                                            </ng-container>
                                        </td>
                                    </ng-container>
                                    <td rowspan="2" class="second-left-col" [class]="j == maker.packageTypes.length - 1 ? 'last-row' : ''">{{packageType.packageType}}</td>
                                    <td class="bg-row third-left-col ssmm">Share</td>
                                    <ng-container *ngFor="let item of categories; index as k;">
                                        <td class="bg-row"><b>{{getShareOfCategory(packageType.categories, item)}}</b></td>
                                    </ng-container>
                                </tr>
                                <tr [class]="j == maker.packageTypes.length - 1 ? 'last-row' : ''">
                                    <td class="third-left-col ssmm">Diff.LY</td>
                                    <ng-container *ngFor="let item of categories; index as k;">
                                        <td [class]="getVsLyOfCategory(packageType.categories, item).indexOf('-') != -1 ? 'text-red': ''">{{getVsLyOfCategory(packageType.categories, item).indexOf('-') != -1 ? '': '+'}}{{getVsLyOfCategory(packageType.categories, item)}}</td>
                                    </ng-container>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </table>
                </div>
                <div class="d-flex flex-two-ends mt-4 hide-pdf-print">
                    <comment-button title1="OTC Market Value Share by Package Size" [screen]="screen"
                        [users]="users" [chartId]="chartId"
                        [chatIdDependency]="[{selectedWeek, state:{aggregateBy: aggregateBy ?? 'wtd', selectedChannel, marketShareSelectedRegion}}]"></comment-button>

                    <download-button>
                        <button ngbDropdownItem (click)="exportOTCMarketValueShareBySSMS(true)">Download PNG</button>
                        <button ngbDropdownItem (click)="exportOTCMarketValueShareBySSMS(false)">Download CSV</button>
                        <button ngbDropdownItem (click)="downloadAsPDF('OTC Market Value Share by Package Size')">Download PDF</button>
                    </download-button>
                </div>
            </div>
            <!--FPT-MyNT15 [2022/11/30][SENSE][1203444563290052] Intage OTC report add download PNG-->
            <div id="download">
                <img #canvas>
                <a #downloadLink></a>
            </div>
        </div>
    </div>
</div>